import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge needs to know about the Milqit theme tokens, otherwise custom
 * utilities like `text-body-s` are mistaken for text colours and get dropped.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        "forest",
        "pine",
        "leaf",
        "butter",
        "clay",
        "coral",
        "lime",
        "paper",
        "shell",
        "mint",
        "cream",
        "blush",
        "sky",
        "sage",
        "ink-900",
        "ink-600",
        "ink-400",
        "line-200",
        "line-300",
        "success",
        "warning",
        "danger",
        "info",
      ],
      shadow: ["float", "card", "lift", "soft"],
      font: ["display", "hand"],
    },
    classGroups: {
      "font-size": [
        { text: ["caps", "body-s", "body-m", "body-l", "h4", "h3", "h2", "price", "mono-s"] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
